// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "-legacy." + {"325":"4f704972","840":"c41a8e06"}[chunkId] + ".js";
};